import React from "react";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import AddVoucher from "./addVoucher";


const AddVoucherContainer = () => {
    return (
        <div className="list">
            <Sidebar />
            <div className="listContainer">
                <Navbar />
                <AddVoucher />

            </div>
        </div>
    )
}

export default AddVoucherContainer;
